import React from "react";
import { Box, Button } from "@curves/ui-base";
import PropTypes from "prop-types";
import CommonTabs from "@icoach/components/layout/CommonTabs";
import clsx from "clsx";

const TabsWithActions = ({ className, tabs, activeTab, onTabChange, actions }) => {
	
	return (
		<Box className={clsx("page-tabs tabs-bottom-line", className)}>
			<CommonTabs tabs={tabs} onTabChange={onTabChange} activeTab={activeTab} />
			{actions && (
				<Box className="btn-group">
					{actions.map(({ label, variant, onClick, as, to }) => (
						<Button key={label} variant={variant} onClick={onClick} component={as} to={to}>
							{label}
						</Button>
					))}
				</Box>
			)}
		</Box>
	);
};

TabsWithActions.prototype = {
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.node.isRequired,
			value: PropTypes.string.isRequired,
			icon: PropTypes.any,
			component: PropTypes.elementType,
			to: PropTypes.string,
		})
	).isRequired,
	activeTab: PropTypes.string,
	onTabChange: PropTypes.func,
	actions: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.node.isRequired,
			variant: PropTypes.oneOf(["contained", "outlined", "text"]),
			onClick: PropTypes.func.isRequired,
		})
	),
};

export default TabsWithActions;
